import { render, staticRenderFns } from "./Tzgg.vue?vue&type=template&id=ca6bd4c2&scoped=true&"
import script from "./Tzgg.vue?vue&type=script&lang=js&"
export * from "./Tzgg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca6bd4c2",
  null
  
)

export default component.exports